import {
    MAJ_LOADING_MODAL_OPERATION,
    MAJ_LOADING_TABLE_OPERATION,
    MAJ_RUBRIQUES_ENTREES,
    MAJ_RUBRIQUES_SORTIES,
    // SET_NOTY_MESSAGE
} from '../mutations-type'
var _ = require('underscore');

// initial state
const state = {
    loadingModalOperation:false,
    loadingTableOperation:false,
    rubriquesSorties:[],
    rubriquesEntrees:[],
    notyMessage:null
}

// mutations
const mutations = {
    [MAJ_LOADING_MODAL_OPERATION] (state, loading) {
        state.loadingModalOperation = loading
    },
    [MAJ_LOADING_TABLE_OPERATION] (state, loading) {
        state.loadingTableOperation = loading
    },
    [MAJ_RUBRIQUES_ENTREES] (state, msg) {
        state.rubriquesEntrees = msg
    },
    [MAJ_RUBRIQUES_SORTIES] (state, msg) {
        state.rubriquesSorties = msg
    },
}
const actions = {
    majLoadingModalOperation({commit},loading) {
        commit(MAJ_LOADING_MODAL_OPERATION,loading)
    },
    majLoadingTableOperation({commit},loading) {
        commit(MAJ_LOADING_TABLE_OPERATION,loading)
    },
    setRubriquesEntrees({commit},msg) {
        commit(MAJ_RUBRIQUES_ENTREES,msg)
    },
    setRubriquesSorties({commit},msg) {
        commit(MAJ_RUBRIQUES_SORTIES,msg)
    },
}

const getters = {
    getLoadingModalOperation : state => {
        return state.loadingModalOperation;
    },
    getLoadingTableOperation : state => {
        return state.loadingTableOperation;
    },
    getNotyMessage: state => {
        return state.notyMessage;
    },
    getRubriquesEntrees:state => {
        return state.rubriquesEntrees;
    },
    getRubriquesSorties:state => {
        return state.rubriquesSorties;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/general.js